var getters = {
  // userName: state => state.app.userName
  userId: function userId(state) {
    return state.app.userId;
  },
  vin: function vin(state) {
    return state.app.vin;
  },
  language: function language(state) {
    return state.app.language;
  },
  socialToken: function socialToken(state) {
    return state.app.socialToken;
  },
  nickname: function nickname(state) {
    return state.app.nickname;
  },
  isOwner: function isOwner(state) {
    return state.app.isOwner;
  },
  avatar: function avatar(state) {
    return state.app.avatar;
  },
  token: function token(state) {
    return state.app.token;
  }
};
export default getters;